.picture {
  display: block;
  width: 100%;
  height: var(--me-picture-height, auto);
  position: relative;
}

.picture img {
  display: block;
  width: 100%;
  height: var(--me-picture-img-height, auto);
  max-height: 100%;
  object-fit: var(--me-picture-object-fit, contain);
}
